import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#3ccfb7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.667 2.6v4.734H1.334V2.601a.6.6 0 0 1 .6-.6h12.133a.6.6 0 0 1 .6.6M12 4.666h.667M1.333 7.333l.383 1.251A2 2 0 0 0 3.628 10H4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#3ccfb7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m14.667 7.333-.382 1.251A2 2 0 0 1 12.372 10H12M6.333 9.666s0 4.667-2.333 4.667M9.667 9.666s0 4.667 2.333 4.667M8 9.666v4.667"
    }, null, -1)
  ]))]))
}
export default { render: render }